const YANDEX_TEAM_SSO_DOMAIN = 'yandex-team.ru';

export function createPassportYandexSsoAuthUrl({
    passportBase,
    login,
    origin,
    retPath,
}: {
    passportBase: string;
    login?: string;
    origin: string;
    retPath: string;
}): string {
    const url = new URL('/auth', passportBase);

    url.searchParams.set('sso_domain', YANDEX_TEAM_SSO_DOMAIN);
    url.searchParams.set('origin', origin);
    url.searchParams.set('retpath', retPath);

    if (login) {
        url.searchParams.set('login', login);
    }

    return url.toString();
}
